import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import validatejs from "validate.js";
import { removeEntries, mapValues } from "./object.js";
export var validateRulesAndValues = function validateRulesAndValues(rules) {
  return function (values) {
    // Discard rules that do not apply to given values. We define
    // initialValues for every form, so all relevant keys should be
    // present in values.
    var filteredRules = removeEntries(rules, function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return !(key in values);
    });
    var errors = validatejs(values, filteredRules) || {};
    return mapValues(errors, function (messages) {
      return messages[0];
    });
  };
};